export default "__VITE_ASSET__4a05832c__"